import React from 'react';
import SiteflowConfig from '@/components/SiteflowConfig';

const ConfigPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Configuration</h1>
      <SiteflowConfig />
    </div>
  );
};

export default ConfigPage; 